module.exports = __webpack_public_path__ + "img/Sanitätszug_Arzt.3e822723.svg";